import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon38: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        fillRule="evenodd"
        d="M14.851 0a.45.45 0 0 1 .45.45v3.067l2.602 3.25.01.019.011.011.016.038c.011.02.021.04.03.063l.016.049c.005.021.005.041.007.06l.007.041v7.45c0 .762-.25 1.461-.663 2.036-.014.021-.02.044-.037.063-.012.013-.027.019-.041.031A3.484 3.484 0 0 1 14.499 18H3.502a3.48 3.48 0 0 1-2.725-1.331c-.03-.02-.061-.034-.086-.061a.477.477 0 0 1-.081-.139A3.482 3.482 0 0 1 0 14.498v-7.45C0 7.032.006 7.016.008 7c.003-.022.005-.043.012-.065a.457.457 0 0 1 .041-.1c.007-.012.008-.027.015-.038.004-.005.009-.006.012-.011l.011-.019 2.602-3.251V.45a.45.45 0 0 1 .45-.45h11.7ZM9.598 10.363a.895.895 0 0 0-1.193 0l-6.736 5.978c.47.469 1.118.759 1.833.759h10.997c.716 0 1.364-.291 1.834-.76l-6.735-5.977ZM.9 7.892v6.606c0 .394.095.764.252 1.098l4.834-4.289L.9 7.892Zm16.2 0-5.083 3.415 4.832 4.288c.157-.335.251-.704.251-1.097V7.892ZM14.401.9h-10.8v7.722l3.08 2.067 1.126-.999a1.796 1.796 0 0 1 2.389.001l1.125.998 3.08-2.068V.9Zm-11.7 4.056L1.107 6.947l1.594 1.07V4.956Zm12.6.002v3.059l1.593-1.07-1.593-1.989ZM12.15 5.4a.45.45 0 0 1 0 .9h-6.3a.45.45 0 0 1 0-.9h6.3Zm0-2.7a.45.45 0 0 1 0 .9h-6.3a.45.45 0 0 1 0-.9h6.3Z"
        clipRule="evenodd"
      />
    </Svg>
  )
}
